// Constantes do editor de roteiro (ProspectTripEditor e seus mixins).
export const PALETTE = ["#7857a8", "#0f766e", "#c2410c", "#1d4ed8", "#be185d", "#4d7c0f", "#b45309", "#334155"];

export const WARNINGS = { day: "não coube no dia combinado", time: "chega depois do horário combinado", window: "fora da janela" };

export const WEEKDAYS = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];

// Etapas do editor, na ordem do trabalho.
export const STEPS = [
    { value: "casos", title: "Casos e equipes" },
    { value: "viagem", title: "Como chegar" },
    { value: "rota", title: "Rota e agenda" },
    { value: "revisar", title: "Revisar e gerar" },
];

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
